import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IRouletteIconProps extends ISvgIconProps {

}

export class RouletteIcon extends React.Component<IRouletteIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M11.985 2.865a9.12 9.12 0 1 1 -6.471 2.68 9.152 9.152 0 0 1 6.471 -2.68m0 17.102a7.951 7.951 0 1 0 -7.951 -7.951 7.951 7.951 0 0 0 7.951 7.951"/>
                    <path d="M11.391 18.419h1.2v2.32h-1.2z"/>
                    <path d="M3.303 11.34h2.32v1.2h-2.32z"/>
                    <path d="M18.426 11.34h2.48v1.2h-2.48z"/>
                    <path d="M11.391 3.14h1.2v2.48h-1.2z"/>
                    <path d="M12.918 10.99a1.36 1.36 0 1 1 -1.92 0 1.36 1.36 0 0 1 1.92 0"/>
                    <path d="M9.273 7.727a0.986 0.986 0 1 1 -1.395 0 0.987 0.987 0 0 1 1.395 0"/>
                    <path d="M7.874 14.77a0.986 0.986 0 1 1 0 1.395 0.987 0.987 0 0 1 0 -1.395"/>
                    <path d="M15.614 14.487a0.986 0.986 0 1 1 -0.986 0.986 0.986 0.986 0 0 1 0.986 -0.986"/>
                    <path d="M16.32 9.129a0.986 0.986 0 1 1 0 -1.395 0.987 0.987 0 0 1 0 1.395Z"/>
                    <path d="m14.254 10.64 -0.897 -0.8 1.67 -1.872 0.897 0.8Z"/>
                    <path d="m8.106 8.767 0.897 -0.799 1.67 1.876 -0.897 0.799z"/>
                    <path d="m8.974 15.981 -0.897 -0.8 1.67 -1.876 0.897 0.8Z"/>
                    <path d="m13.357 14.104 0.897 -0.799 1.67 1.876 -0.897 0.799z"/>
                </g>
            </SvgIcon>
        );
    }
}
